import {Component, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {

  reviwes: any;
  modalRef: BsModalRef;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  @ViewChild("view", {static: true}) view;
  newsForm: any;
  dest: any;
  course: any;
  upId: any;
  up: boolean;
  noteTitle: any;
  note: any;
  ty: string;
  searchform: any;
  page: any;
  totalRec: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService,) {
    this.newsForm = this.formBuilder.group({
      title: ["", [Validators.required]],
      desc: ["", [Validators.required]],
      dest: ["", [Validators.required]],
    });

    this.searchform = this.formBuilder.group({
      search: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    this.getAlldest();
    this.getAllCourse();
  }



  getAlldest(){
    this.userService.getallDestinations().subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.dest = res.data
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  getAllCourse(){
    this.course =null;
    this.userService.getAllCorse().subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.course = res.data
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  reject(id: any) {

  }

  viewMore() {
    this.ty ='New'
    this.newsForm.reset();
    this.up =false;
    this.addModal.show();
  }

  createCourse(){
    let req ={
      description: this.newsForm.controls.desc.value,
      name: this.newsForm.controls.title.value,
    }

    this.userService.createCorse(req,this.newsForm.controls.dest.value).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.addModal.hide()
          this.getAllCourse();
          this.newsForm.reset();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  dlete(id) {
    this.userService.delteCorse(id).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.getAllCourse();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  update(obj) {
    this.ty='Update'
    this.addModal.show();
    this.up=true;
    this.upId=obj.id;
    this.newsForm.controls['title'].setValue(obj.name);
    this.newsForm.controls['desc'].setValue(obj.description);
    this.newsForm.controls['dest'].setValue(obj.studyDestination.id);
  }

  viewDesc(pac){
    this.noteTitle =pac.name;
    this.note =pac.description;
    this.view.show()
  }

  upAction(){
    let req ={
      id:this.upId,
      description: this.newsForm.controls.desc.value,
      name: this.newsForm.controls.title.value,
    }

    this.userService.createCorse(req,this.newsForm.controls.dest.value).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.addModal.hide()
          this.up=false;
          this.newsForm.reset();
          this.getAllCourse();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  search(pageIndex) {
    let size = 10;
    let page = pageIndex - 1;
    this.userService.searchCorse(this.searchform.controls.search.value,size,page).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.course =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )

  }
}
